<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M13.95 3.6c-.153 0-.306.018-.45.054v-.729c0-.99-.81-1.8-1.8-1.8-.189 0-.378.027-.549.081A1.795 1.795 0 0 0 9.45 0c-.864 0-1.584.603-1.755 1.422A1.829 1.829 0 0 0 7.2 1.35c-.99 0-1.8.81-1.8 1.8v4.86a1.831 1.831 0 0 0-.657-.405l-.927-.324a1.371 1.371 0 0 0-.459-.081c-.9 0-1.611.927-1.251 1.845l1.962 4.986A6.272 6.272 0 0 0 9.9 18a5.85 5.85 0 0 0 5.85-5.85V5.4c0-.99-.81-1.8-1.8-1.8Zm.45 8.55c0 2.484-2.016 4.5-4.5 4.5a4.9 4.9 0 0 1-4.563-3.114L3.384 8.559l.72.252c.243.09.441.279.54.522L5.4 11.25h1.35v-8.1c0-.252.198-.45.45-.45s.45.198.45.45V9H9V1.8c0-.252.198-.45.45-.45s.45.198.45.45V9h1.35V2.925c0-.252.198-.45.45-.45s.45.198.45.45V9h1.35V5.4c0-.252.198-.45.45-.45s.45.198.45.45v6.75Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
